import { createContext, useContext, useState } from 'react';
import useServiceActions from '../hooks/APIHooks/appointments/useServiceActions';
import { Service } from '../types/services';

// datatype of the context declared here
interface IServiceContext {
  serviceList: Array<Service>;
  isError: boolean;
  isLoading: boolean;
  isSuccess: boolean;
  service: Service | null;
  showDeleteModal: boolean;
  showAddToPopularModal: boolean;
  showUpdateModal: boolean;
  setService: React.Dispatch<React.SetStateAction<Service | null>>;
  setShowDeleteModal: React.Dispatch<React.SetStateAction<boolean>>;
  setShowAddToPopularModal: React.Dispatch<React.SetStateAction<boolean>>;
  setShowUpdateModal: React.Dispatch<React.SetStateAction<boolean>>;
}

// creating the context here
const ServiceContext = createContext<IServiceContext | null>(null);

const ServiceProvider = ({ children }: { children: React.ReactNode }) => {
  // integration of react hooks here
  const [service, setService] = useState<Service | null>(null);

  const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false);
  const [showAddToPopularModal, setShowAddToPopularModal] =
    useState<boolean>(false);
  const [showUpdateModal, setShowUpdateModal] = useState<boolean>(false);

  // integration of API hooks here
  const { getServiceListHandler } = useServiceActions('serviceList');

  console.log('SERVICE LIST: ', getServiceListHandler.data?.data);

  // rendering the context provider here
  return (
    <ServiceContext.Provider
      value={{
        serviceList: getServiceListHandler.data?.data || [],
        isError: getServiceListHandler.isError,
        isLoading: getServiceListHandler.isLoading,
        isSuccess: getServiceListHandler.isSuccess,
        service,
        showDeleteModal,
        showAddToPopularModal,
        showUpdateModal,
        setService,
        setShowDeleteModal,
        setShowAddToPopularModal,
        setShowUpdateModal,
      }}
    >
      {children}
    </ServiceContext.Provider>
  );
};

export default ServiceProvider;

// custom hook to access the service context declared here
export const useServiceContext = () => {
  const context = useContext(ServiceContext);

  if (!context) {
    throw new Error('useServiceContext must be within ServiceProvider!');
  }

  return context;
};
